import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "text-gray-600 body-font" }
const _hoisted_2 = { class: "border-t border-gray-200" }
const _hoisted_3 = { class: "container px-5 py-8 flex flex-wrap mx-auto items-center" }
const _hoisted_4 = {
  key: 0,
  class: "flex md:flex-nowrap flex-wrap justify-center items-end md:justify-start"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"relative sm:w-64 w-40 sm:mr-4 mr-2\"><label for=\"footer-field\" class=\"leading-7 text-sm text-gray-600\"> Placeholder </label><input type=\"text\" id=\"footer-field\" name=\"footer-field\" class=\"w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-blue-200 focus:border-blue-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out\"></div><button class=\"inline-flex text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded\"> Button </button><p class=\"text-gray-500 text-sm md:ml-6 md:mt-0 mt-2 sm:text-left text-center\"> Bitters chicharrones fanny pack <br class=\"lg:block hidden\">waistcoat green juice </p>", 3)
const _hoisted_8 = [
  _hoisted_5
]
const _hoisted_9 = { class: "inline-flex lg:ml-auto lg:mt-0 mt-6 w-full justify-center md:justify-start md:w-auto" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "bg-gray-100 dark:bg-gray-900" }
const _hoisted_12 = { class: "container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row" }
const _hoisted_13 = { class: "text-gray-500 text-sm text-center sm:text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.linkedin.com/in/diego-perez-2055-arg/",
  class: "text-gray-600 ml-1 dark:text-primary",
  target: "_blank",
  rel: "noopener noreferrer"
}, "@dforce2055", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "sm:ml-auto sm:mt-0 mt-2 sm:w-auto w-full sm:text-left text-center text-gray-500 text-sm" }, "Enamel pin tousled raclette tacos irony", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialsMedia, (socialMedia, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              href: socialMedia.url,
              target: "_blank",
              class: "hover:text-primary mr-3"
            }, [
              _createVNode(_component_mdicon, {
                name: socialMedia.icon,
                size: _ctx.mediaSize
              }, null, 8, ["name", "size"])
            ], 8, _hoisted_10))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, [
          _createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + " dforce2055 — ", 1),
          _hoisted_14
        ]),
        _hoisted_15
      ])
    ])
  ]))
}